<command-menu
  [filterPage]="filterPage"
  [showDottedMenu]="true"
  [inverted]="true"
  [showExport]="true"
  [canEditColumns]="false"
  (onExport)="saveTable()"
></command-menu>
<nested-table
  style="padding-bottom: 30px;"
  [items]="tableData"
  [filtersId]="filterPage"
  [condensedView]="condensed"
  [columns]="columnData"
  [readOnly]="true"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [menuDisabled]="busy"
  [defaultSelectedColumnId]="quoteColumns.resource"
  (selectItem)="manageQuote($event)"
  (updatedSelectedIds)="selectIds($event)"
  [emptyMessage]="'No quotes in this account'"
></nested-table>